import React from 'react';
import { ArrowDownUp } from 'lucide-react';
import type { RecipientSort, RecipientSortKey } from '../types';

interface SortableHeaderProps {
  label: string;
  sortKey: RecipientSortKey;
  sort: RecipientSort | null;
  onSort: (_key: RecipientSortKey) => void;
  className?: string;
}

export const SortableHeader: React.FC<SortableHeaderProps> = ({
  label,
  sortKey,
  sort,
  onSort,
  className,
}) => {
  const isActive = sort?.key === sortKey;

  return (
    <th className={`h-12 text-left align-middle font-medium ${className ?? 'px-5'}`}>
      <button
        type="button"
        onClick={() => onSort(sortKey)}
        className="inline-flex items-center gap-1.5 text-sm font-medium text-gray-500 hover:text-gray-800"
      >
        {label}
        <ArrowDownUp
          className={`h-3.5 w-3.5 shrink-0 ${isActive ? 'text-gray-800' : 'text-gray-400'}`}
          strokeWidth={1.75}
        />
      </button>
    </th>
  );
};
